import { apiSlice } from './apiSlice';

const cafeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEightCafeInfo: builder.query({
      query: ({ limit, skip }) => ({
        url: `/cafes/items`,
        params: { limit, skip },
      }),
      providesTags: ['CafeProfile'],
    }),
    getMatchCafeInfoByInput: builder.query({
      query: ({ input, limit, next }) => ({
        url: `/cafes`,
        params: { input, limit, next },
      }),
      providesTags: ['CafeProfile'],
    }),
    getCafeProfile: builder.query({
      query: (_id) => `/cafes/${_id}`,
      providesTags: ['CafeProfile'],
    }),
    registerCafe: builder.mutation({
      query: (data) => {
        const { body } = data;
        return {
          url: `/cafes`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['CafeProfile'],
    }),
    getCafeDetails: builder.query({
      query: (count) => `/cafes/${count}/details`,
      providesTags: ['CafeProfile'],
    }),
    editCafe: builder.mutation({
      query: ({ cafeId, body }) => ({
        url: `/cafes/${cafeId}/update`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    likeCafe: builder.mutation({
      query: ({ cafeId, userId }) => ({
        url: `/cafes/${cafeId}/like`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    unlikeCafe: builder.mutation({
      query: ({ cafeId, userId }) => ({
        url: `/cafes/${cafeId}/unlike`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    followCafe: builder.mutation({
      query: ({ cafeId, userId }) => ({
        url: `/cafes/${cafeId}/follow`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    unfollowCafe: builder.mutation({
      query: ({ cafeId, userId }) => ({
        url: `/cafes/${cafeId}/unfollow`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    addCafeRating: builder.mutation({
      query: ({ ratingObj }) => ({
        url: `/cafes/${ratingObj.cafeId}/ratings`,
        method: 'POST',
        body: ratingObj,
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    updateCafeRating: builder.mutation({
      query: ({ ratingObj }) => ({
        url: `/cafes/${ratingObj.cafeId}/ratings/update`,
        method: 'PUT',
        body: ratingObj,
      }),
      invalidatesTags: ['CafeProfile'],
    }),
    getCafeDetails: builder.query({
      query: (count) => `/cafes/${count}/details`,
      providesTags: ['CafeProfile'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetEightCafeInfoQuery,
  useGetMatchCafeInfoByInputQuery,
  useGetCafeProfileQuery,
  useRegisterCafeMutation,
  useEditCafeMutation,
  useLikeCafeMutation,
  useUnlikeCafeMutation,
  useFollowCafeMutation,
  useUnfollowCafeMutation,
  useAddCafeRatingMutation,
  useUpdateCafeRatingMutation,
  useGetCafeDetailsQuery,
} = cafeApi;
